/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Conflict,
  Forbidden,
  InstallationRequestModel,
  InstallationUpdateModel,
  NotFound,
  PVBatteryModel,
  PVBatteryResponseModel,
  ServiceUnavailable,
  Unauthorized,
} from '../models';

export interface CrmInstallationsPvBatteryAddSmartEnergyDeviceRequest {
    id: string;
    installationRequestModel: InstallationRequestModel;
}

export interface CrmInstallationsPvBatteryDeleteSmartEnergyDeviceRequest {
    id: string;
    configurationId: string;
}

export interface CrmInstallationsPvBatteryGetSmartEnergyDeviceRequest {
    id: string;
    installationId: string;
}

export interface CrmInstallationsPvBatteryGetSmartEnergyDevicesRequest {
    id: string;
    useCache?: string;
}

export interface CrmInstallationsPvBatteryLookupDevicesRequest {
    id: string;
    serialnumber: string;
    vendorName?: string;
}

export interface CrmInstallationsPvBatteryUpdateSmartEnergyDeviceRequest {
    id: string;
    configurationId: string;
    installationUpdateModel: InstallationUpdateModel;
}

/**
 * 
 */
export class CRMInstallationsPVBatteryApi extends runtime.BaseAPI {

    /**
     * Creates a new photovoltaic and battery storage installation for a customer. Configures solar panels, inverters, battery systems, connection parameters, and integrates with vendor monitoring platforms
     * Add PV & Battery Installation
     */
    async crmInstallationsPvBatteryAddSmartEnergyDeviceRaw(requestParameters: CrmInstallationsPvBatteryAddSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PVBatteryResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsPvBatteryAddSmartEnergyDevice.');
        }

        if (requestParameters.installationRequestModel === null || requestParameters.installationRequestModel === undefined) {
            throw new runtime.RequiredError('installationRequestModel','Required parameter requestParameters.installationRequestModel was null or undefined when calling crmInstallationsPvBatteryAddSmartEnergyDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/pvbattery`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.installationRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new photovoltaic and battery storage installation for a customer. Configures solar panels, inverters, battery systems, connection parameters, and integrates with vendor monitoring platforms
     * Add PV & Battery Installation
     */
    async crmInstallationsPvBatteryAddSmartEnergyDevice(requestParameters: CrmInstallationsPvBatteryAddSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PVBatteryResponseModel> {
        const response = await this.crmInstallationsPvBatteryAddSmartEnergyDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a PV/battery installation configuration from the customer account. This action permanently removes the installation setup and disconnects from vendor monitoring platforms. Cannot be undone
     * Remove PV & Battery Configuration
     */
    async crmInstallationsPvBatteryDeleteSmartEnergyDeviceRaw(requestParameters: CrmInstallationsPvBatteryDeleteSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsPvBatteryDeleteSmartEnergyDevice.');
        }

        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling crmInstallationsPvBatteryDeleteSmartEnergyDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/pvbattery/{configurationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a PV/battery installation configuration from the customer account. This action permanently removes the installation setup and disconnects from vendor monitoring platforms. Cannot be undone
     * Remove PV & Battery Configuration
     */
    async crmInstallationsPvBatteryDeleteSmartEnergyDevice(requestParameters: CrmInstallationsPvBatteryDeleteSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmInstallationsPvBatteryDeleteSmartEnergyDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves detailed configuration for a specific PV/battery installation by installation ID. Returns complete system setup including solar panels, inverters, battery storage, and energy monitoring parameters
     * Find PV & Battery Installation
     */
    async crmInstallationsPvBatteryGetSmartEnergyDeviceRaw(requestParameters: CrmInstallationsPvBatteryGetSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PVBatteryModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsPvBatteryGetSmartEnergyDevice.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling crmInstallationsPvBatteryGetSmartEnergyDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/pvbattery/{installationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves detailed configuration for a specific PV/battery installation by installation ID. Returns complete system setup including solar panels, inverters, battery storage, and energy monitoring parameters
     * Find PV & Battery Installation
     */
    async crmInstallationsPvBatteryGetSmartEnergyDevice(requestParameters: CrmInstallationsPvBatteryGetSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PVBatteryModel> {
        const response = await this.crmInstallationsPvBatteryGetSmartEnergyDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all photovoltaic and battery storage installations for a customer. Returns comprehensive device configurations including solar panels, inverters, battery systems, and monitoring settings. Supports optional cache control
     * Get All PV & Battery Installations
     */
    async crmInstallationsPvBatteryGetSmartEnergyDevicesRaw(requestParameters: CrmInstallationsPvBatteryGetSmartEnergyDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PVBatteryModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsPvBatteryGetSmartEnergyDevices.');
        }

        const queryParameters: any = {};

        if (requestParameters.useCache !== undefined) {
            queryParameters['useCache'] = requestParameters.useCache;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/pvbattery`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all photovoltaic and battery storage installations for a customer. Returns comprehensive device configurations including solar panels, inverters, battery systems, and monitoring settings. Supports optional cache control
     * Get All PV & Battery Installations
     */
    async crmInstallationsPvBatteryGetSmartEnergyDevices(requestParameters: CrmInstallationsPvBatteryGetSmartEnergyDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PVBatteryModel>> {
        const response = await this.crmInstallationsPvBatteryGetSmartEnergyDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves device information from vendor systems using the device serial number. Queries vendor APIs (Fronius, Kostal, Sungrow) to fetch detailed specifications, configuration data, and installation parameters for setup assistance
     * Lookup PV Battery by Serial Number
     */
    async crmInstallationsPvBatteryLookupDevicesRaw(requestParameters: CrmInstallationsPvBatteryLookupDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallationRequestModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsPvBatteryLookupDevices.');
        }

        if (requestParameters.serialnumber === null || requestParameters.serialnumber === undefined) {
            throw new runtime.RequiredError('serialnumber','Required parameter requestParameters.serialnumber was null or undefined when calling crmInstallationsPvBatteryLookupDevices.');
        }

        const queryParameters: any = {};

        if (requestParameters.serialnumber !== undefined) {
            queryParameters['serialnumber'] = requestParameters.serialnumber;
        }

        if (requestParameters.vendorName !== undefined) {
            queryParameters['vendorName'] = requestParameters.vendorName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/pvbattery/lookup`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves device information from vendor systems using the device serial number. Queries vendor APIs (Fronius, Kostal, Sungrow) to fetch detailed specifications, configuration data, and installation parameters for setup assistance
     * Lookup PV Battery by Serial Number
     */
    async crmInstallationsPvBatteryLookupDevices(requestParameters: CrmInstallationsPvBatteryLookupDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallationRequestModel> {
        const response = await this.crmInstallationsPvBatteryLookupDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing PV/battery installation configuration. Modifies device settings, system parameters, monitoring credentials, or energy management policies. Changes are synchronized with vendor platforms
     * Update PV & Battery Configuration
     */
    async crmInstallationsPvBatteryUpdateSmartEnergyDeviceRaw(requestParameters: CrmInstallationsPvBatteryUpdateSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PVBatteryModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsPvBatteryUpdateSmartEnergyDevice.');
        }

        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling crmInstallationsPvBatteryUpdateSmartEnergyDevice.');
        }

        if (requestParameters.installationUpdateModel === null || requestParameters.installationUpdateModel === undefined) {
            throw new runtime.RequiredError('installationUpdateModel','Required parameter requestParameters.installationUpdateModel was null or undefined when calling crmInstallationsPvBatteryUpdateSmartEnergyDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/pvbattery/{configurationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.installationUpdateModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Updates an existing PV/battery installation configuration. Modifies device settings, system parameters, monitoring credentials, or energy management policies. Changes are synchronized with vendor platforms
     * Update PV & Battery Configuration
     */
    async crmInstallationsPvBatteryUpdateSmartEnergyDevice(requestParameters: CrmInstallationsPvBatteryUpdateSmartEnergyDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PVBatteryModel> {
        const response = await this.crmInstallationsPvBatteryUpdateSmartEnergyDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
